/**
 * User: n.gorte
 * Date: 28.06.2022
 * Time: 15:26
 */

export const SearchBox = L.Control.extend({
    options: {
        position: 'topleft',
        expand: 'right',
        collapsed: true,
        icon: 'fa fa-search',
        title: 'Suchen',
        placeholder: '',
    },
    onHideHandlers: [],

    addTo: function(map) {
        this.remove();
        this._map = map;

        var container = this._container = this.onAdd(map),
            pos = this.getPosition(),
            corner = map._controlCorners[pos];

        L.DomUtil.addClass(container, 'leaflet-control');

        if (pos.indexOf('bottom') !== -1) {
            corner.insertBefore(container, corner.firstChild);
        } else {
            corner.appendChild(container);
        }

        this._map.on('unload', this.remove, this);

        return this;
    },

    onAdd(map) {
        this._container = L.DomUtil.create('div', 'leaflet-searchbox-container');
        this._searchboxWrapper = L.DomUtil.create('div', 'leaflet-searchbox-wrapper', this._container);
        this._autocompleteWrapper = L.DomUtil.create('div', 'leaflet-searchbox-autocomplete-wrapper', this._container);

        this._createButton();
        this._createInput();
        this._createClearButton();

        this._collapsed = this.options.collapsed;
        if (this.options.collapsed) {
            this.hide();
        }

        L.DomEvent.disableClickPropagation(this._container);

        L.DomEvent.on(this._button, 'click', this._onClick, this);
        L.DomEvent.on(this._clearButton, 'click', this.clear, this);
        return this._container;
    },

    onRemove(map) {
        L.DomEvent.off(this._button);
        L.DomEvent.off(this._input);
        L.DomEvent.off(this._clearButton);
        L.DomEvent.off(this._container);
        this.onHideHandlers = [];
    },

    getValue() {
        return this._input.value;
    },

    setValue(value) {
        this._input.value = value;
    },

    hide() {
        L.DomUtil.addClass(this._container, 'collapsed');
        L.DomUtil.removeClass(this._button, 'active');
        L.DomUtil.removeClass(this._clearButton, 'active');
        this._input.blur();
        this._button.blur();
        this._collapsed = true;
        this.onHideHandlers.forEach(handler => handler());
    },

    show() {
        L.DomUtil.removeClass(this._container, 'collapsed');
        L.DomUtil.addClass(this._button, 'active');
        L.DomUtil.addClass(this._clearButton, 'active');
        this._collapsed = false;
        // this._input.focus();
    },

    toggle() {
        if (L.DomUtil.hasClass(this._container, 'collapsed')) {
            this.show();
        } else {
            this.hide();
        }
    },

    onHide(handler) {
        this.onHideHandlers.push(handler);
    },

    offHide(handler) {
        this.onHideHandlers = this.onHideHandlers.filter(item => item !== handler);
    },

    isCollapsed() {
        return L.DomUtil.hasClass(this._container, 'collapsed');
    },

    clearInput() {
        this._input.value = '';
    },

    clear: function() {
        this.clearInput();
    },

    onClear(event, handler) {
        L.DomEvent.on(this._clearButton, event, handler, this);
    },

    offClear(event, handler) {
        L.DomEvent.off(this._clearButton, event, handler, this);
    },

    onInput(event, handler) {
        L.DomEvent.on(this._input, event, handler, this);
    },

    offInput(event, handler) {
        L.DomEvent.off(this._input, event, handler, this);
    },

    onButton(event, handler) {
        const wrapper = this._buttonHandlerWrapper(handler);
        L.DomEvent.on(this._button, event, wrapper, this);
    },

    offButton(event, handler) {
        const wrapper = this._buttonHandlerWrapper(handler);
        L.DomEvent.off(this._button, event, wrapper, this);
    },

    _onClick() {
        this.toggle();
    },

    _buttonHandlerWrapper(handler) {
        return function() {
            if (!this._collapsed) {
                handler();
            }
        };
    },

    _createButton() {
        const position = this.options.expand === 'left' ? 'right' : 'left';
        this._button = L.DomUtil.create('div', 'leaflet-bar leaflet-control-custom leaflet-searchbox-button leaflet-searchbox-button-' + position,
            this._searchboxWrapper);
        this._button.setAttribute('type', 'button');
        this._button.setAttribute('role', 'button');
        this._button.setAttribute('title', this.options.title);
        this._icon = L.DomUtil.create('span', this.options.icon, this._button);
    },

    _createInput() {
        const position = this.options.expand === 'left' ? 'left' : 'right';
        this._input = L.DomUtil.create('input', 'leaflet-searchbox leaflet-searchbox-' + position, this._searchboxWrapper);
        this._input.setAttribute('type', 'text');
        this._input.setAttribute('placeholder', this.options.placeholder);
        this._input.setAttribute('enterkeyhint', 'done');
        L.DomEvent.on(this._input, 'keyup', (keyboardEvent) => {
            const key = keyboardEvent.code || keyboardEvent.keyCode;
            if (key === 'Enter' || key === 13) {
                this._input.blur();
            }
        }, this);

        if (this.options.expand === 'left') {
            L.DomUtil.toBack(this._input);
        }
    },

    _createClearButton() {
        this._clearButton = L.DomUtil.create('i', 'clear-button fa fa-times', this._searchboxWrapper);
    }
});



// WEBPACK FOOTER //
// ./js/plugins/SearchPlugin/SearchBox.js